<div
  class="card ziro-card mb-4"
  [ngClass]="{ disabled: isDisabled() && !isError() && !isRefreshing() }"
  (click)="onCardClick($event)"
>
  <div
    class="card-body d-flex flex-column"
    [ngClass]="{ 'not-allowed-cursor': isDisabled() && !isError() && !isRefreshing() }"
  >
    <ziro-migrations-card-header [label]="label()" [labelTooltip]="labelTooltip()"></ziro-migrations-card-header>

    <div class="d-flex justify-content-center align-items-center flex-grow-1 w-100">
      @if (isRefreshing() || (!isError() && !isDisabled() && (!data() || data()?.length === 0))) {
        <div class="text-center">
          <i data-automation="card-refreshing" class="icon {{ ZiroIcons.LOADING }}"></i>
        </div>
      } @else if (isError()) {
        <div class="text-center" data-automation="card-error">
          <i class="icon {{ ZiroIcons.CIRCLE_EXCLAMATION }} text-danger"></i>
          <h5 data-automation="card-error-title">
            {{ 'tkey;migrations.cisco.directory_numbers_report.dashboard.usage_type.error.title' | translate }}
          </h5>
          <p data-automation="card-error-description">
            {{ 'tkey;migrations.cisco.directory_numbers_report.dashboard.usage_type.error.description' | translate }}
          </p>
          <ziro-button
            [dataAutomation]="'card-error-refresh-button'"
            [label]="'tkey;migrations.cisco.directory_numbers_report.dashboard.refresh'"
            [icon]="ZiroIcons.REFRESH"
            (clicked)="onErrorButtonClick()"
          ></ziro-button>
        </div>
      } @else if (isDisabled()) {
        <div class="text-center" data-automation="card-disabled">
          <i class="icon {{ ZiroIcons.CIRCLE_EXCLAMATION }} text-muted"></i>
          <h5 data-automation="card-disabled-title">
            {{ disabledText()?.header | translate }}
          </h5>
          <p data-automation="card-disabled-description">
            {{ disabledText()?.description | translate }}
          </p>
        </div>
      } @else {
        <ziro-migration-text-row [data]="data()"></ziro-migration-text-row>
      }
    </div>
  </div>
</div>
